/**
* Sticky Jump Links JS
* -----------------------------------------------------------------------------
*
* All the JS for the Sticky Jump Links component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'sticky-jump-links',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 768 ) {
        let topOffset = $( 'header' ).height() + 180;
        if ( $( 'body.logged-in' ).length > 0 ) {
          topOffset += 32;
        }

        $( '.sticky-jump-links__content' ).each( function() {
          const jumpLink = '#jump-link-'+$( this ).attr( 'id' );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: `top top+=${topOffset}`,
              end: `bottom top+=${topOffset}`,
              // markers: true,
              onEnter: ( {progress, direction, isActive} ) => {
                $( jumpLink ).addClass( 'active' );
              },
              onLeave: ( {progress, direction, isActive} ) => {
                $( jumpLink ).removeClass( 'active' );
              },
              onEnterBack: ( {progress, direction, isActive} ) => {
                $( jumpLink ).addClass( 'active' );
              },
              onLeaveBack: ( {progress, direction, isActive} ) => {
                $( jumpLink ).removeClass( 'active' );
              },
            },
          } );
          tl.to( $( jumpLink ), {
            addClass: 'active',
          } );
        } );
      }

      function handleLargeChange( event ) {
        if ( event.matches && !$( '.sticky-jump-links-content' ).hasClass( 'is-open' ) ) {
          $( '.sticky-jump-links-content' ).attr( 'aria-hidden', true );
        } else if ( !event.matches && !$( '.sticky-jump-links-content' ).hasClass( 'is-open' ) ) {
          $( '.sticky-jump-links-content' ).attr( 'aria-hidden', false );
        } else if ( !event.matches && $( '.sticky-jump-links__toggle' ).hasClass( 'is-open' ) ) {
          $( '.sticky-jump-links__toggle' ).trigger( 'click' );
          $( '.sticky-jump-links-content' ).attr( 'aria-hidden', false );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(max-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleLargeChange );
      // handleLargeChange( window.matchMedia( '(max-width: 1024px)' ) );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'sticky-jump-links', COMPONENT );
} )( app );
